import React, { CSSProperties } from "react";

import DatePickerV2 from "../datePicker/DatePicker.v2";

import { cransmontana_translations } from "./cransmontana.searchwidget.translations";
import Icon from "src/components/icon";
import DateTime from "src/utils/temporalLuxonUtil";
import CTAButton from "src/components/ctabutton";
import { getLanguageField } from "src/utils/language";

type CransMontanaSearchWidgetTabProps = {
    tab: string;
    activeTab: string;
    onClick: any;
    icon: string;
    label: string;
    className: string;
}

class CransMontanaSearchWidgetTab extends React.Component<CransMontanaSearchWidgetTabProps> {
    render() {
        const active = this.props.activeTab === this.props.tab;        
        return <>
            <button onClick={this.props.onClick} className={`border-[color:var(--sw-primary)] ${!active ? "bg-[color:var(--sw-primary-75)]" : "!border-white"} border-b-2 bg-[color:var(--sw-primary)] p-4 flex-1 flex flex-col gap-2 items-center justify-center md:min-h-[4rem]`}>
                <Icon width={26} height={26} icon={this.props.icon as any} className="min-w-[26px] min-h-[26px]" />
                <span className="searchWidgetDetail">{this.props.label}</span>
            </button>
        </>
    }
}

class CransMontanaSearchWidgetTabs extends React.Component<{ activeTab: string, setActiveTab: any, selectedLanguage: string }> {
    setActiveTab(tab: string) {
        this.props.setActiveTab(tab);
    }

    render() {
        const firstTabLabel = getLanguageField(cransmontana_translations.tabs[0].translations, this.props.selectedLanguage, "name") as string;
        const secondTabLabel = getLanguageField(cransmontana_translations.tabs[1].translations, this.props.selectedLanguage, "name") as string;
        return <>
            <div className="flex rounded-t-2xl overflow-hidden h-[90px]">
                <CransMontanaSearchWidgetTab className="" icon="DayPasses" label={firstTabLabel} tab="day-passes" activeTab={this.props.activeTab} onClick={() => this.setActiveTab('day-passes')} />
                <CransMontanaSearchWidgetTab className="" icon="LongPasses2" label={secondTabLabel} tab="long-passes" activeTab={this.props.activeTab} onClick={() => this.setActiveTab('long-passes')} />
            </div>
        </>
    }
}


type CransMontanaSearchWidgetLongPassesProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    selectedLanguage: string;
    defaultLanguage: string
}

class CransMontanaSearchWidgetLongPasses extends React.Component<CransMontanaSearchWidgetLongPassesProps> {
    get link() {
        const link = `${getLanguageField(
            cransmontana_translations.tabs[1].translations, this.props.selectedLanguage, "cta_href")}${this.startDate ? `?start_date=${this.startDate}` : ""}`;
        return link;
    }

    get buttonText() {
        return getLanguageField(cransmontana_translations.tabs[1].translations, this.props.selectedLanguage, "cta_label") as string
    };

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    get searchMessage() {
        return getLanguageField(cransmontana_translations.tabs[1].translations, this.props.selectedLanguage, "search_message") as string
    }

    render() {
        const { startDate, setStartDate, selectedLanguage } = this.props;

        return <>
            <div className={`bg-[color:var(--sw-primary)] flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
                <div className="w-full flex flex-col gap-4 md:flex-row md:gap-6 items-center justify-center text-white">
                    <span className="generalText">{this.searchMessage}</span>
                    <div className="w-full md:w-1/3">
                        <DatePickerV2
                            selectedDayBgColor={'var(--sw-secondary)'}
                            openToDate={new Date(startDate)}
                            startDate={new Date(startDate)}
                            value={new Date(startDate)}
                            includeDateIntervals={false}
                            locale={selectedLanguage}
                            onChange={(date: Date) => { setStartDate(date) }}
                            calendarChevronColor="black"
                        />
                    </div>
                </div>
                <div className="w-full lg:w-1/4">
                    <CTAButton className="uppercase" open_in_same_tab={true} link={this.link} color="#000000" bgcolor="#F4F4F4" hoverbgcolor="#284361" hovercolor="#fffff" type="primary" text={this.buttonText} icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                </div>
            </div>
        </>
    }
}

type CransMontanaSearchWidgetDayPassesProps = {
    startDate: Date;
    setStartDate: (date: Date) => void;
    selectedLanguage: string;
    defaultLanguage: string
}

class CransMontanaSearchWidgetDayPasses extends React.Component<CransMontanaSearchWidgetDayPassesProps> {

    get link() {
        const link = `${getLanguageField(cransmontana_translations.tabs[0].translations, this.props.selectedLanguage, "cta_href")}${this.startDate ? `?start_date=${this.startDate}` : ""}`;
        return link;
    }

    get buttonText() {
        return getLanguageField(cransmontana_translations.tabs[0].translations, this.props.selectedLanguage, "cta_label") as string
    };

    get startDate() {
        return DateTime.fromJSDate(this.props.startDate).toFormat("yyyy-MM-dd");
    }

    get searchMessage() {
        return getLanguageField(cransmontana_translations.tabs[0].translations, this.props.selectedLanguage, "search_message") as string
    }

    render() {
        const { startDate, setStartDate, selectedLanguage } = this.props;

        return <>
            <div className={`bg-[color:var(--sw-primary)] flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
                <div className="w-full flex flex-col gap-4 md:flex-row md:gap-6 items-center justify-center text-white">
                    <span className="generalText">{this.searchMessage}</span>
                    <div className="w-full md:w-1/3">
                        <DatePickerV2
                            selectedDayBgColor={'var(--sw-secondary)'}
                            openToDate={new Date(startDate)}
                            startDate={new Date(startDate)}
                            value={new Date(startDate)}
                            includeDateIntervals={false}
                            locale={selectedLanguage}
                            onChange={(date: Date) => { setStartDate(date) }}
                            calendarChevronColor="black"
                        />
                    </div>
                </div>
                <div className="w-full lg:w-1/4">
                    <CTAButton className="uppercase" open_in_same_tab={true} link={this.link} color="#000000" bgcolor="#F4F4F4" hoverbgcolor="#284361" hovercolor="#fffff" type="primary" text={this.buttonText} icon={<Icon className="w-6 h-4" icon="ArrowRight" />} />
                </div>
            </div>
        </>
    }
}

type SearchWidgetProps = {
    selectedLanguage: string;
    defaultLanguage: string;
    removeMargin: boolean;
}

type SearchWidgetState = {
    tab: "day-passes" | "long-passes",
    startDate: Date;
}

export default class CransMontanaSearchWidget extends React.Component<SearchWidgetProps, SearchWidgetState> {
    static minimumDate() {
        const baseDate = new Date();
        const hour = baseDate.getHours();
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        const tomorrow = DateTime.fromJSDate(baseDate).startOf("day").plus({ day: 1 }).startOf("day").toJSDate();
        const minimumStart = hour >= 15 ? tomorrow : today;
        return minimumStart;
    }


    static minimumLTDate() {
        const baseDate = new Date('2024-01-01');
        const hour = baseDate.getHours();
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        const tomorrow = DateTime.fromJSDate(baseDate).startOf("day").plus({ day: 1 }).startOf("day").toJSDate();
        const minimumStart = hour >= 15 ? tomorrow : today;
        return minimumStart;
    }

    state: SearchWidgetState = {
        tab: "day-passes",
        startDate: CransMontanaSearchWidget.minimumDate(),
    }

    setActiveTab = (tab: any) => {
        this.setState({ tab });
    }

    setStartDate = (date: Date) => {
        this.setState({ startDate: date });
    }

    get style() {
        return {
            '--sw-primary': '#F01717',
            '--sw-primary-75': '#D93F3FBF',
            '--sw-secondary': '#EFB7B7',
            filter: "drop-shadow(0px 2px 15px rgba(37, 37, 39, 0.15))"
        } as CSSProperties;
    }

    render() {
        return <>
            <div className={`${this.props.removeMargin ? "" : "mt-[-90px]"} flex w-full justify-center px-6 lg:px-10 relative z-[2] flex-col`} style={this.style}>
                <div className="w-full sm:max-w-6xl lg:max-w-7xl justify-center m-auto flex flex-col text-white searchWidgetText">
                    <CransMontanaSearchWidgetTabs activeTab={this.state.tab} setActiveTab={this.setActiveTab} selectedLanguage={this.props.selectedLanguage} />
                    {this.state.tab === 'day-passes' ? <CransMontanaSearchWidgetDayPasses
                        startDate={this.state.startDate > CransMontanaSearchWidget.minimumLTDate() ? this.state.startDate : CransMontanaSearchWidget.minimumLTDate()}
                        setStartDate={this.setStartDate}
                        selectedLanguage={this.props.selectedLanguage}
                        defaultLanguage={this.props.defaultLanguage}
                    /> : null}
                    {this.state.tab === 'long-passes' ? <CransMontanaSearchWidgetLongPasses
                        startDate={this.state.startDate > CransMontanaSearchWidget.minimumLTDate() ? this.state.startDate : CransMontanaSearchWidget.minimumLTDate()}
                        setStartDate={this.setStartDate}
                        selectedLanguage={this.props.selectedLanguage}
                        defaultLanguage={this.props.defaultLanguage}
                    /> : null}
                </div>
            </div>
        </>
    }

}